/* global $ */

import Swiper, { Pagination, Autoplay, EffectFade } from 'swiper';

class PageHome {
  constructor() {
    this.id = this.getRandomId();
    this.$window = $(window);

    this.$statement_primary = $('.Statement--primary');
    this.$statement_secondary = $('.Statement--secondary');

    this.swiper = new Swiper('.Slideshow', {
      modules: [Pagination, Autoplay, EffectFade],
      loop: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      autoplay: {
        pauseOnMouseEnter: false,
        delay: 5000,
      },
      effect: 'fade',
    });

    this.$window
      .on('resize.' + this.id, () => {
        this.onWindowResize();
      })
      .on('scroll.' + this.id, () => {
        this.onWindowScroll();
      });
    this.onWindowResize();
  }
  onWindowResize() {
    this.windowHeight = window.innerHeight;
    this.onWindowScroll();
  }
  onWindowScroll() {
    this.heroHeight = parseInt($('.Hero').height() - 34);
    this.scrollTop = this.$window.scrollTop();

    let moveRange = parseInt(this.$statement_primary.outerHeight());
    let moveVal = parseInt((this.scrollTop / this.heroHeight) * moveRange);

    if (moveVal > moveRange) moveVal = moveRange;

    this.$statement_primary.css('margin-top', `-${moveVal}px`);

    let secondaryBaseScrollVal =
      (this.scrollTop -
        ($('.Business__statement').offset()['top'] - this.windowHeight)) /
      (this.windowHeight * 0.8);
    if (secondaryBaseScrollVal < 0) secondaryBaseScrollVal = 0;
    if (secondaryBaseScrollVal > 1) secondaryBaseScrollVal = 1;

    this.$statement_secondary.css(
      'transform',
      `translateY(${100 - secondaryBaseScrollVal * 100}%)`,
    );
  }
  getRandomId() {
    let c = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let cl = c.length;
    let r = '';
    for (var i = 0; i < 8; i++) {
      r += c[Math.floor(Math.random() * cl)];
    }
    return r;
  }
  destroy() {
    this.swiper.destroy();
    this.$window.off('.' + this.id);
  }
}

export default PageHome;
